







import { Vue, Component, Prop } from 'vue-property-decorator'

type item = {
  src: string
  caption: string
}

@Component
export default class Carousel extends Vue {
  
  @Prop ({ type: Array }) items!: item[]

  model = 0

}
